// src/writer/components/SelectionModal.tsx
import React from 'react';
import { ProjectState } from '../types/project';
import { BookStructureElementKey } from '../types';
import { primaryButtonClass, secondaryButtonClass } from '../constants';
import SelectiveGenerationInterface from './SelectiveGenerationInterface';

interface SelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onProceed: (selectedElements: BookStructureElementKey[]) => void;
  projectState: ProjectState;
  isGenerating: boolean;
}

const SelectionModal: React.FC<SelectionModalProps> = ({
  isOpen,
  onClose,
  onProceed,
  projectState,
  isGenerating
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        {/* Modal Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <div>
            <h2 className="text-2xl font-semibold text-gray-800">
              ✨ Select Elements to Generate
            </h2>
            <p className="text-sm text-gray-600 mt-1">
              Choose which front matter, back matter, and publishing elements you want AI to generate
            </p>
          </div>
          <button
            onClick={onClose}
            disabled={isGenerating}
            className="text-gray-400 hover:text-gray-600 text-2xl disabled:opacity-50"
            title="Close"
          >
            ✕
          </button>
        </div>

        {/* Modal Body - Scrollable with proper spacing for generate button */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)] flex flex-col">
          <SelectiveGenerationInterface
            projectState={projectState}
            onGenerateSelected={onProceed}
            isGenerating={isGenerating}
            isModal={true}
          />

          {/* Modal controls */}
          <div className="flex justify-between items-center mt-6 pt-4 border-t border-gray-200">
            <div className="text-sm text-gray-600">
              💡 Your selections will be remembered for future generations
            </div>
            <button
              onClick={onClose}
              disabled={isGenerating}
              className={`${secondaryButtonClass} px-4 py-2 disabled:opacity-50`}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectionModal;